module.exports = __webpack_public_path__ + "static/media/ar.91013f67.svg";